import {CPSConstants} from "commonUtils/enumerations";

export const sideBarNavStyles = {
  activeSubMenu: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#C1EA94",
    display: "flex",
    textalgn: "center",
    fontWeight: "bold!important",
    fontSize: "1rem",
    borderRadius: "4px",
    margin: "0px 0px 0px 0px",
    padding: "7px 10px 7px 20px",
    height: "auto",
  },
  inActiveSubMenu: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#EFEFEF",
    display: "flex",
    textalgn: "center",
    fontWeight: "400 !important",
    fontsize: "0.68rem",
    textOverflow: "unset !important",
    margin: "0px 0px 0px 0px",
    padding: "7px 10px 7px 20px",
    height: "auto",
  },
  label: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    overflowWrap: "break-word",
  },
  Menu: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "0.063rem #91D 54A",
    borderradius: "0.3rem",
    paddingLeft: "0rem",
    fontWeight: "bold !important",
    fontsize: "1rem",
    margin: "0 0 0 -7px",
    padding: "0px 10px 0px 5px",
    height: "auto",
  },

  MenuNoChild: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "0.063rem #91D 54A",
    borderradius: "0.3rem",
    paddingLeft: "0rem",
    fontWeight: "bold !important",
    fontsize: "1rem",
    margin: "0px 0px 0px 0px",
    padding: "0 10px 0 0",
    height: "auto",
  },
  sidenavBorderColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderColor: "black !important",
  },
};
